<script lang="ts">
  import type {User} from '../types'
  import api from '../api/api'

  export let user: User

  async function follow() {
    if (!user) return
    await api.put(`/users/${user.id}/follow`)
    user.is_followed = true
    user.followers_count += 1
  }

  async function unfollow() {
    if (!user) return
    await api.put(`/users/${user.id}/unfollow`)
    user.is_followed = false
    user.followers_count -= 1
  }
</script>

<div class="grid__card poet__card">
  <div class="poet__name">
    <a href={user.link}>{user.full_name}</a>
  </div>
  <a class="poet__photo" href={user.link}>
    <img src={user.avatar_big_thumgb} alt={user.full_name}/>
  </a>
  <div class="poet__info">
    <span class="poet__poem__count">
      <i class="icon-p-book"></i> {user.poems_count}
    </span>
    <span class="poet__followers__count">
      <i class="icon-p-user"></i> {user.followers_count}
    </span>
  </div>
  <div class="poet__actions">
    {#if !user.is_followed}
      <span class="poet__follow__btn poet__btn follow-poet" onclick={follow}>
        <i class="icon-p-plus-circle"></i>
      </span>
    {:else}
      <span class="poet__follow__btn poet__btn follow-poet followed" onclick={unfollow}>
        <i class="icon-p-check"></i>
      </span>
    {/if}
  </div>
</div>
